export default __webpack_public_path__ + "static/media/buses-page1400.8cb8584c.jpg";